import { InventoryTypeFieldOptionMessage } from "./InventoryTypeFieldOptionMessage"

export class CreateInventoryTypeFieldMessage {
  name: string
  displayOrder: number
  type: number
  isRequired: boolean

  inventoryTypeFieldOptions: InventoryTypeFieldOptionMessage[]

  constructor(name: string, displayOrder: number, type: number, isRequired: boolean, inventoryTypeFieldOptions: InventoryTypeFieldOptionMessage[]) {
    this.name = name
    this.displayOrder = displayOrder
    this.type = type
    this.isRequired = isRequired
    this.inventoryTypeFieldOptions = inventoryTypeFieldOptions
  }
}
